
import React, { useState } from 'react';
import hicon from '../../images/icon/magic.svg'
import { Fade } from "react-awesome-reveal";
import {
    Accordion,
    AccordionBody,
    AccordionHeader,
    AccordionItem,
} from 'reactstrap';

const FaqSection = (props) => {

    const [open, setOpen] = useState('1');
    const toggle = (id) => {
        if (open === id) {
            setOpen();
        } else {
            setOpen(id);
        }
    };

    return (
        <section className="faq pb-140 mt-5">
            <div className="container">
                <div className="sec-title--two text-center mb-60">
                    <Fade direction='down' triggerOnce={'false'} duration={1000} delay={9}>
                        <div>
                            <div className="sub-title wow fadeInDown" data-wow-duration="600ms"><img
                                src={hicon} alt="" />FAQ’s</div>
                        </div>
                    </Fade>
                    <Fade direction='up' triggerOnce={'false'} duration={1200} delay={9}>
                        <div>
                            <h2 className="title wow fadeInDown" data-wow-delay="150ms" data-wow-duration="600ms">Common Questions Answered</h2>
                        </div>
                    </Fade>
                </div>
                <div className="row">
                    <div className="col-lg-12">
                        <div className="xb-faq wow fadeInUp" data-wow-delay="200ms" data-wow-duration="600ms">
                            <Accordion open={open} toggle={toggle} className='accordion_box clearfix list-unstyled'>
                                <AccordionItem className='block'>
                                    <AccordionHeader targetId="1" className='acc-btn'><span className="number">01</span> _ How long does Odoo integration take?
                                        <span className="arrow"></span>
                                    </AccordionHeader>
                                    <AccordionBody accordionId="1" className='acc_body'>
                                        <div className="content">
                                            <p>Odoo integration typically takes 2-6 weeks depending on your business complexity and customization needs. Our experienced team ensures a smooth transition with minimal disruption to your operations.</p>
                                            <ul className="list-unstyled">
                                                <li><i className="far fa-check"></i>Assessment of current systems and requirements.</li>
                                                <li><i className="far fa-check"></i>Custom configuration and module setup.</li>
                                                <li><i className="far fa-check"></i>Data migration and testing.</li>
                                            </ul>
                                        </div>
                                    </AccordionBody>
                                </AccordionItem>
                                <AccordionItem className='block'>
                                    <AccordionHeader targetId="2" className='acc-btn'><span className="number">02</span> _ Do you provide Shopify and Magento development?
                                        <span className="arrow"></span>
                                    </AccordionHeader>
                                    <AccordionBody accordionId="2" className='acc_body'>
                                        <div className="content">
                                            <p>Yes! We specialize in both Shopify and Magento development. Whether you need store setup, customization, theme development, or migration from another platform, our expert team can handle it.</p>
                                            <ul className="list-unstyled">
                                                <li><i className="far fa-check"></i>Shopify store design and development.</li>
                                                <li><i className="far fa-check"></i>Magento custom extensions and optimization.</li>
                                                <li><i className="far fa-check"></i>Cross-platform integration and API development.</li>
                                            </ul>
                                        </div>
                                    </AccordionBody>
                                </AccordionItem>
                                <AccordionItem className='block'>
                                    <AccordionHeader targetId="3" className='acc-btn'><span className="number">03</span> _ Can you build custom mobile and web applications?
                                        <span className="arrow"></span>
                                    </AccordionHeader>
                                    <AccordionBody accordionId="3" className='acc_body'>
                                        <div className="content">
                                            <p>Absolutely! Our app development team creates custom solutions for iOS, Android, and web platforms. We use the latest technologies to build scalable, user-friendly applications tailored to your business needs.</p>
                                            <ul className="list-unstyled">
                                                <li><i className="far fa-check"></i>Full-stack web application development.</li>
                                                <li><i className="far fa-check"></i>Native and cross-platform mobile apps.</li>
                                                <li><i className="far fa-check"></i>Real-time API and backend services.</li>
                                            </ul>
                                        </div>
                                    </AccordionBody>
                                </AccordionItem>
                                <AccordionItem className='block'>
                                    <AccordionHeader targetId="4" className='acc-btn'><span className="number">04</span> _ Do you handle e-commerce inventory and order management?
                                        <span className="arrow"></span>
                                    </AccordionHeader>
                                    <AccordionBody accordionId="4" className='acc_body'>
                                        <div className="content">
                                            <p>Yes! We provide comprehensive e-commerce solutions including inventory management, order tracking, payment gateway integration, and automated workflows across all your sales channels.</p>
                                            <ul className="list-unstyled">
                                                <li><i className="far fa-check"></i>Multi-channel inventory synchronization.</li>
                                                <li><i className="far fa-check"></i>Automated order processing and fulfillment.</li>
                                                <li><i className="far fa-check"></i>Advanced reporting and analytics.</li>
                                            </ul>
                                        </div>
                                    </AccordionBody>
                                </AccordionItem>
                                <AccordionItem className='block'>
                                    <AccordionHeader targetId="5" className='acc-btn'><span className="number">05</span> _ What support and maintenance do you offer?
                                        <span className="arrow"></span>
                                    </AccordionHeader>
                                    <AccordionBody accordionId="5" className='acc_body'>
                                        <div className="content">
                                            <p>We provide ongoing support and maintenance for all our projects. This includes regular updates, security patches, performance optimization, and 24/7 technical support to ensure your systems run smoothly.</p>
                                            <ul className="list-unstyled">
                                                <li><i className="far fa-check"></i>Proactive monitoring and maintenance.</li>
                                                <li><i className="far fa-check"></i>Regular security updates and backups.</li>
                                                <li><i className="far fa-check"></i>Dedicated support team and SLA guarantees.</li>
                                            </ul>
                                        </div>
                                    </AccordionBody>
                                </AccordionItem>
                            </Accordion>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
};
export default FaqSection;
